import { computed, ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

interface IuseRouteContextComposable {
  isSchoolContext: ComputedRef<boolean>;
  isProviderContext: ComputedRef<boolean>;
  isClassContext: ComputedRef<boolean>;
  isWaitingRoomContext: ComputedRef<boolean>;
  isStudentContext: ComputedRef<boolean>;
  isAuthContext: ComputedRef<boolean>;
  isOnboardingContext: ComputedRef<boolean>;
  isInvitationContext: ComputedRef<boolean>;
  isOnboardingFlowContext: ComputedRef<boolean>;
}

export const useRouteContext = (): IuseRouteContextComposable => {
  const route = useRoute();

  const normalizedPath = computed(() => {
    return route.path.replace(/^\/+/, '/');
  });

  const isSchoolContext = computed(() => normalizedPath.value.startsWith('/school/'));

  const isProviderContext = computed(
    () => normalizedPath.value === '/provider' || normalizedPath.value.startsWith('/provider/'),
  );

  const isClassContext = computed(() => normalizedPath.value.startsWith('/class'));

  const isWaitingRoomContext = computed(() => normalizedPath.value.startsWith('/waiting'));

  const isStudentContext = computed(() => route.name === '//class/[classId]/student/[studentId]');

  const isAuthContext = computed(() => normalizedPath.value.startsWith('/auth'));

  const isOnboardingContext = computed(() => normalizedPath.value.startsWith('/onboarding'));

  const isInvitationContext = computed(() => normalizedPath.value.startsWith('/user/invitations'));

  const isOnboardingFlowContext = computed(() => {
    return isAuthContext.value || isOnboardingContext.value || isInvitationContext.value;
  });

  return {
    isSchoolContext,
    isProviderContext,
    isClassContext,
    isWaitingRoomContext,
    isStudentContext,
    isAuthContext,
    isOnboardingContext,
    isInvitationContext,
    isOnboardingFlowContext,
  };
};
